import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { UserEntityPicker } from './UserEntityPicker';

export const UserEntityPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'UserEntityPicker',
    component: UserEntityPicker,
  }),
);